import React, { useEffect, useState } from 'react';
import Header from '../../componets/header/header';
import Footer from '../../componets/footer/footer';
import courseback from "../../../assets/course-back.jpg";
import { useParams } from 'react-router-dom';
import { GET, POST } from '../../../utils/apicalls';
import { API } from '../../../config/api';
import { App, Button, Col, Form, Input, Modal, Row, Tabs } from 'antd';

// @ts-ignore: CSS side-effect import without declaration file
import './commonCourse.css';
import EligibilityCheckForm from '../eligibilitycheckForm';
import course1 from "../../../assets/course1.webp";
import course2 from "../../../assets/eligibility_check.webp";
import course3 from "../../../assets/course2.webp";
import course4 from "../../../assets/course3.webp";
import defalut from "../../../assets/fixed_mage.png";
import EnrollModal from '../../booking-payment/enrollmentModel';
import why1 from '../../../assets/why1.webp';
import whycfe from '../../../assets/course2.webp';
import FormItem from 'antd/es/form/FormItem';

import CourseDisplayCard from './courseDisplayCard';

function Cfcs() {
    const { id } = useParams();
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const [courseDetails, setCourseDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('eligibility');
    const [isEligibilityModalOpen, setIsEligibilityModalOpen] = useState(false);
    const [selectedCourseForEnroll, setSelectedCourseForEnroll] = useState<string | number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const submitHandler = async (values: any) => {
        try {
            let obj = {
                name: values.name,
                email: values.email,
                message: values.message,
                phone: values.phone,
                Course_id: Number(id),
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_COURSE_ENQUIRY, obj);

            if (postRequest) {
                notification.success({ message: "Message sent successfully!" });
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const tabItems = [
        {
            key: 'eligibility',
            label: <div className="tab-label">Eligibility Check</div>,
            children: (
                <div className="tab-content eligibility-tab">
                    <div className="tab-text">
                        <h2>Eligibility Check</h2>
                        <ul>
                            <li>Minimum <strong>40 eligibility credits</strong> as per ACFCS requirements</li>
                            <li>Credits earned through <strong>Education, Professional Experience, Training, and Professional Certifications</strong></li>
                            <li>Bachelor's or Master's degree holders can earn eligibility credits</li>
                            <li>Relevant experience in AML, KYC, Fraud, Compliance, Risk, Banking, Audit, Law Enforcement, or Financial Crime is accepted</li>
                            <li>Financial crime-related training and recognized certifications add additional credits</li>
                            <li>Active <strong>ACFCS Membership</strong> is required to apply for the CFCS examination</li>
                        </ul>
                    </div>
                    <div className="tab-image">
                        <img src={course2} alt="CFCS certification India" />
                    </div>
                </div>
            ),
        },
        {
            key: 'exam',
            label: <div className="tab-label">Pattern and Scoring</div>,
            children: (
                <div className="tab-content exam-tab">
                    <div className="tab-text">
                        <ul>
                            <li><strong>Exam Format:</strong> Scenario-based Multiple Choice Questions (MCQs)</li>
                            <li><strong>Total Questions:</strong> 135 scored questions (additional unscored beta questions may be included)</li>
                            <li><strong>Exam Duration:</strong> 4 Hours (240 Minutes)</li>
                            <li><strong>Passing Score:</strong> 88 out of 135 scored questions (approximately 65%)</li>
                            <li><strong>Mode of Examination:</strong> Online Proctored through Kryterion</li>
                            <li><strong>Question Type:</strong> Practical, case-study, and scenario-based questions</li>
                            <li><strong>Negative Marking:</strong> None</li>
                            <li><strong>Result:</strong> Pass/Fail status displayed after the examination</li>
                        </ul>
                        <p>
                            The CFCS exam evaluates your knowledge across key financial crime domains, including <strong>AML, KYC, Fraud, Sanctions, Corruption, Cybercrime, Financial Investigations, Compliance, and Risk Management.</strong>
                        </p>
                    </div>
                    <div className="tab-image">
                        <img src={course1} alt="CFCS certification India" />
                    </div>
                </div>
            ),
        },
        {
            key: 'outcomes',
            label: <div className="tab-label">Career Opportunities</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <ul>
                            <li>Anti-Money Laundering (AML) Analyst</li>
                            <li>Financial Crime Compliance Analyst</li>
                            <li>KYC / CDD / EDD Analyst</li>
                            <li>Transaction Monitoring Analyst</li>
                            <li>Fraud Analyst / Fraud Investigator</li>
                            <li>Sanctions Screening Analyst</li>
                            <li>Risk & Compliance Analyst</li>
                            <li>Financial Crime Investigator</li>
                            <li>Regulatory Compliance Officer</li>
                            <li>AML Compliance Officer</li>
                            <li>Financial Intelligence Analyst</li>
                            <li>Corporate Compliance Officer</li>
                            <li>Internal Auditor – Financial Crime</li>
                            <li>Risk Consultant</li>
                            <li>Compliance Manager</li>
                            <li>Financial Crime Specialist</li>
                        </ul>

                        <p>
                            <strong>Top Hiring Sectors:</strong> Banks, FinTech Companies, Big 4 Firms, MNCs,
                            NBFCs, Insurance Companies, Consulting Firms, Payment Service Providers,
                            Crypto & FinTech Organizations, and Global Capability Centers (GCCs).
                        </p>
                    </div>
                    <div className="tab-image">
                        <img src={course3} alt="CFCS certification India" />
                    </div>
                </div>
            ),
        },
        {
            key: 'target-audiance',
            label: <div className="tab-label">CFCS Exam Cost</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <ul>
                            <li><strong>Private Sector Members:</strong> USD $1,395</li>
                            <li><strong>Government Sector Members:</strong> USD $1,045</li>
                            <li><strong>Includes:</strong> 1-year ACFCS Membership, Digital Study Manual, Practice Question Bank, Training Videos, Online Exam, and Comprehensive Exam Preparation Resources</li>
                            <li><strong>Exam Retake Fee (if required):</strong> USD $175</li>
                            <li><strong>Recertification:</strong> Every 3 years with applicable continuing education and renewal fee</li>
                        </ul>
                        <i>Note: Fees are subject to change by ACFCS. Contact Meantoir Global Academy, Kochi for the latest pricing and guidance on the CFCS certification process.</i>
                    </div>
                    <div className="tab-image">
                        <img src={course4} alt="CFCS course Kerala" />
                    </div>
                </div>
            ),
        },
    ];

    useEffect(() => {
        const fetchCourseDetails = async () => {
            setIsLoading(true);
            try {
                const response: any = await GET(`${API.GET_COURSE_BY_ID}${id}`, {});
                setCourseDetails(response?.data);
                console.log("Course Response:", response);
            } catch (error) {
                console.error("Error fetching course details:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchCourseDetails();
        }
    }, [id]);

    const [openSection, setOpenSection] = useState<string | null>(null);

    const toggleSection = (section: string) => {
        setOpenSection(prev => (prev === section ? null : section));
    };

    const showModal = (courseId: string | number, e: React.MouseEvent) => {
        e.stopPropagation();
        setSelectedCourseForEnroll(courseId);
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedCourseForEnroll(null);
    };


    const whycfctexts = [
        <>
            <strong>Globally recognized financial crime certification</strong> with thousands of certified professionals across <strong>80+ countries and jurisdictions</strong>.
        </>,

        <>
            <strong>Future-ready, AI-resilient career</strong> requiring expertise in <strong>AML, KYC, fraud detection, investigations, and financial crime compliance</strong>.
        </>,

        <>
            Preferred by <strong>global banks, FinTechs, Big 4 firms, MNCs, regulators, law enforcement agencies, and financial institutions</strong>.
        </>,

        <>
            Opens doors to <strong>high-demand roles in AML, Financial Crime Compliance, Fraud Prevention, Sanctions, Risk Management, and Regulatory Compliance</strong>.
        </>,

        <>
            Covers <strong>AML, Fraud, Cybercrime, Corruption, Sanctions, Cryptocurrency, Financial Crime Investigations, and Regulatory Compliance</strong> in one globally respected certification.
        </>,

        <>
            <strong>Fast-track your career</strong>—become <strong>exam-ready in 3–4 months</strong> with structured coaching and expert guidance.
        </>,
    ];

    const whyTexts = [
        "Kerala's First & Only dedicated CFCS coaching provider",
        "One of the most affordable CFCS coaching programs in India",
        "Expert faculty with industry-focused and updated study materials",
        "Comprehensive mock exams & scenario-based practice tests",
        "Complete guidance from eligibility assessment to CFCS certification",
        "Career-focused training in AML, KYC, Fraud, Sanctions & Financial Crime Compliance",
        "Strong placement support for opportunities in Banks, Big 4, FinTechs & MNCs",
        "100% Placement Assistance",
        "Premium Online & Offline Batches (Malayalam & English)",
        "Mentorship from Big 4, Banking & Financial Crime Compliance Professionals",
    ];
    const faqItems = [
        {
            key: "whatIsCfcs",
            q: "Q1: What is the Certified Financial Crime Specialist (CFCS) certification?",
            a: "The Certified Financial Crime Specialist (CFCS) is a globally recognized certification offered by the Association of Certified Financial Crime Specialists (ACFCS). It validates expertise in Anti-Money Laundering (AML), KYC, Fraud, Sanctions, Cybercrime, Financial Crime Investigations, and Regulatory Compliance.",
        },
        {
            key: "whoShouldPursue",
            q: "Q2: Who should pursue the CFCS certification?",
            a: "CFCS is ideal for banking professionals, AML/KYC analysts, compliance officers, fraud investigators, auditors, risk professionals, law enforcement officers, finance professionals, accountants, lawyers, and graduates seeking a career in financial crime compliance.",
        },
        {
            key: "globallyRecognized",
            q: "Q3: Is CFCS recognized globally?",
            a: "Yes. CFCS is recognized by employers and financial institutions across 80+ countries and jurisdictions, making it a valuable credential for global career opportunities.",
        },
        {
            key: "eligibilityRequirements",
            q: "Q4: What are the eligibility requirements for CFCS?",
            a: "Candidates must meet the minimum 40-credit eligibility requirement based on education, professional experience, training, and professional certifications, along with an active ACFCS membership.",
        },
        {
            key: "freshGraduates",
            q: "Q5: Can fresh graduates apply for CFCS?",
            a: "Yes. Fresh graduates who satisfy the ACFCS eligibility criteria can pursue the CFCS certification and build careers in financial crime compliance.",
        },
        {
            key: "prepTime",
            q: "Q6: How long does it take to prepare for the CFCS exam?",
            a: "Most candidates complete their preparation in 3-4 months with a structured study plan and expert coaching.",
        },
        {
            key: "examTopics",
            q: "Q7: What topics are covered in the CFCS exam?",
            a: "The exam covers AML, KYC, Fraud, Financial Crime Investigations, Sanctions, Cybercrime, Corruption, Compliance, Ethics, Cryptocurrency, and Risk Management.",
        },
        {
            key: "examPattern",
            q: "Q8: What is the CFCS exam pattern?",
            a: "The CFCS exam consists of 135 scored multiple-choice questions, is 4 hours long, and is conducted online through remote proctoring.",
        },
        {
            key: "passingScore",
            q: "Q9: What is the passing score for the CFCS exam?",
            a: "Candidates must score 88 out of 135 scored questions to pass the examination.",
        },
        {
            key: "onlineExam",
            q: "Q10: Is the CFCS exam conducted online?",
            a: "Yes. The CFCS examination is conducted through online remote proctoring, allowing candidates to take the exam from an approved location.",
        },
        {
            key: "careerOpportunities",
            q: "Q11: What career opportunities are available after CFCS?",
            a: "CFCS-certified professionals can work as AML Analysts, Financial Crime Analysts, KYC Analysts, Fraud Analysts, Compliance Officers, Risk Analysts, Sanctions Analysts, Financial Crime Investigators, and Regulatory Compliance Specialists.",
        },
        {
            key: "hiringCompanies",
            q: "Q12: Which companies hire CFCS-certified professionals?",
            a: "Global banks, FinTech companies, Big 4 firms, MNCs, NBFCs, insurance companies, consulting firms, payment service providers, and regulatory organizations actively recruit CFCS-certified professionals.",
        },
        {
            key: "worthPursuing",
            q: "Q13: Is CFCS worth pursuing?",
            a: "Yes. CFCS is one of the most comprehensive financial crime certifications, helping professionals build expertise in AML, fraud prevention, compliance, and financial crime investigations while enhancing career growth.",
        },
        {
            key: "cfcsVsCams",
            q: "Q14: What is the difference between CFCS and CAMS?",
            a: "CAMS focuses primarily on Anti-Money Laundering (AML), while CFCS covers a broader spectrum, including AML, Fraud, KYC, Sanctions, Cybercrime, Corruption, Financial Crime Investigations, and Compliance.",
        },
        {
            key: "cfcsVsCfe",
            q: "Q15: What is the difference between CFCS and CFE?",
            a: "CFE specializes in fraud examination and investigations, whereas CFCS provides broader expertise across the entire financial crime ecosystem, including AML, sanctions, fraud, cybercrime, compliance, and financial intelligence.",
        },
        {
            key: "workExperience",
            q: "Q16: Is work experience mandatory for CFCS?",
            a: "Not necessarily. Eligibility depends on achieving the required 40 credits, which can be earned through a combination of education, work experience, training, and certifications.",
        },
        {
            key: "cfcsCost",
            q: "Q17: How much does the CFCS certification cost?",
            a: "The certification fee depends on the applicant category and ACFCS membership. Contact Meantoir Global Academy for the latest fee details and enrollment guidance.",
        },
        {
            key: "meantoirProvides",
            q: "Q18: Does Meantoir Global Academy provide CFCS coaching?",
            a: "Yes. Meantoir Global Academy, Kochi, Kerala, is Kerala's First & Only dedicated CFCS coaching provider, offering comprehensive online and offline coaching with expert faculty.",
        },
        {
            key: "placementAssistance",
            q: "Q19: Does Meantoir provide placement assistance?",
            a: "Yes. We offer 100% placement assistance, including resume building, interview preparation, career guidance, and job support for opportunities in banks, Big 4 firms, FinTechs, and MNCs.",
        },
        {
            key: "whyMeantoir",
            q: "Q20: Why choose Meantoir Global Academy for CFCS coaching?",
            a: "Meantoir offers expert faculty, updated study materials, scenario-based mock exams, flexible online & offline batches (Malayalam & English), career mentoring, free eligibility assessment, and complete guidance from enrollment to certification and placement.",
        },
        {
            key: "onlineClasses",
            q: "Q21: Can I attend CFCS classes online?",
            a: "Yes. We offer live online classes along with classroom training, enabling students from across India and abroad to prepare for the CFCS examination.",
        },
        {
            key: "studyMaterials",
            q: "Q22: Do you provide study materials and mock tests?",
            a: "Yes. Students receive comprehensive study materials, practice questions, mock exams, revision sessions, and exam strategies to maximize their chances of success.",
        },
        {
            key: "professionalsEligible",
            q: "Q23: Can CA, ACCA, CPA, CMA, CS, and MBA professionals pursue CFCS?",
            a: "Absolutely. CFCS is highly beneficial for CA, ACCA, CPA, CMA, CS, MBA, B.Com, M.Com, law graduates, auditors, and finance professionals looking to advance in financial crime compliance.",
        },
        {
            key: "jobAbroad",
            q: "Q24: Can CFCS help me get a job abroad?",
            a: "Yes. Since CFCS is internationally recognized, it can strengthen your profile for financial crime, AML, compliance, and risk management roles with multinational organizations worldwide.",
        },
        {
            key: "howToEnroll",
            q: "Q25: How do I enroll for CFCS coaching at Meantoir Global Academy?",
            a: "Simply contact Meantoir Global Academy for a FREE CFCS eligibility assessment, personalized counseling, batch schedules, and enrollment assistance. Our team will guide you throughout your CFCS certification journey.",
        },
    ];

    return (
        <div>
            <Header />
            <div className="course-page-container">
                <div className="course-hero">
                    <img src={courseback} alt="CFCS course Kerala" className="course-hero-image" />
                    <div className="course-hero-overlay"></div>

                    <div className="course-hero-inner">
                        {/* Left Content */}
                        <div className="course-hero-content left-content">
                            <h1>
                                {isLoading
                                    ? "Loading..."
                                    : courseDetails?.course_title
                                        ?.replace(/\s*\(.*?\)/, "") || "Certified Financial Crime Specialist Course in Kerala, India "}

                                {!isLoading && courseDetails?.course_title?.match(/\(.*?\)/) && (
                                    <h1>
                                        {courseDetails.course_title.match(/\(.*?\)/)?.[0]}
                                    </h1>
                                )}
                            </h1>
                            <i>(Globally Recognized Financial Crime Prevention Expert)</i>
                            <p>{courseDetails?.course_duration || "3 Exams | 3-4 Months"}</p>
                            <p>
                                Earn up to 12+ LPA in just 4 months! <br />
                                Jobs at Big 4, Banks, MNCs & Risk Consulting Firms
                            </p>

                            <Button
                                className="courseCard-button primary-button"
                                type="primary"
                                onClick={(e) => showModal(id!, e)}
                            >
                                Enroll Now
                            </Button>

                            {isModalVisible && (
                                <EnrollModal
                                    visible={isModalVisible}
                                    onClose={handleCloseModal}
                                    courseId={selectedCourseForEnroll}
                                />
                            )}
                        </div>

                        {/* Right Form */}
                        <div className="course-hero-content right-form">
                            <h2>  Make an Enquiry</h2>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={submitHandler}
                                initialValues={{
                                    name: '',
                                    phone: '',
                                    email: '',
                                    message: '',
                                }}
                            >
                                <Row gutter={24}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Name"
                                            name="name"
                                            rules={[{ required: true, message: 'Please enter your name' }]}
                                        >
                                            <Input placeholder="Your Name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone"
                                            name="phone"
                                            rules={[{ required: true, message: 'Please enter your phone' }]}
                                        >
                                            <Input placeholder="Your phone" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                            rules={[{ required: true, message: 'Please enter your email' }]}
                                        >
                                            <Input type="email" placeholder="Email Address" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Message"
                                            name="message"
                                            rules={[{ required: true, message: 'Please enter your message' }]}
                                        >
                                            <Input.TextArea rows={3} placeholder="Your message" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <FormItem>
                                    <Button type="primary" htmlType="submit">Submit</Button>
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>

                <div className='main-section-course' style={{ padding: "20px" }}>
                    <div className='course-details-section'>
                        <div className='course-details-text'>
                            <ul style={{ listStyle: "none" }} className="course-details-description">
                                {courseDetails?.course_description?.map((desc: string, idx: number) => (
                                    <li key={idx} dangerouslySetInnerHTML={{ __html: desc }} />
                                ))}
                            </ul>
                        </div>
                        <div className="course-details-image">
                            <img
                                src={courseDetails?.course_certificate_image || defalut}
                                alt="CFCS course Kerala"
                                style={{
                                    height: '400px',
                                    width: '90%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>
                    </div>

                    <div>
                        <br />
                        <h2 className="homepage-heading">About Certified Financial Crime Specialist</h2>

                        <div className="course-details-tabs-container">
                            <div className="course-details-tabs">
                                <Tabs
                                    activeKey={activeTab}
                                    onChange={setActiveTab}
                                    type="card"
                                    className="custom-tabs"
                                    items={tabItems}
                                    centered
                                />
                            </div>
                        </div>

                        <Modal
                            title="Check Eligibility"
                            open={isEligibilityModalOpen}
                            onCancel={() => setIsEligibilityModalOpen(false)}
                            footer={null}
                            width={600}
                        >
                            <EligibilityCheckForm
                                courseId={id ? Number(id) : 0}
                                onClose={() => setIsEligibilityModalOpen(false)}
                            />
                        </Modal>
                    </div>
                </div>

                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <img src={whycfe} alt="Financial crime specialist course India" className="home-why-image" />
                        </div>
                        <div className="home-why-right">
                            <h2 className="homepage-heading">Why Certified Financial Crime Specialist (CFCS)?</h2>
                            <ul className="home-why-list">
                                {whycfctexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <h2 className="homepage-heading">Why Meantoir for CFCS?</h2>
                            <ul className="home-why-list">
                                {whyTexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="home-why-right">
                            <img src={why1} alt="Financial crime specialist course India" className="home-why-image" />
                        </div>
                    </div>
                </div>

                <div className="ea-section-container">
                    <div>
                        <div style={{ textAlign: "center" }}>
                            <h2 style={{ width: "100%", textAlign: "center", fontSize: "2.5rem", }}>Frequently Asked Questions(FAQ's)</h2>
                        </div>
                        <div>
                            {faqItems.map((item) => (
                                <div key={item.key}>
                                    <h3
                                        onClick={() => toggleSection(item.key)}
                                        style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}
                                    >
                                        {item.q}
                                    </h3>
                                    {openSection === item.key && (
                                        <p style={{ width: "100%", fontSize: "1.5rem" }}>
                                            {item.a}
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <h2 className="homepage-heading">Explore More Courses</h2>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                    <CourseDisplayCard />
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Cfcs;
